import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-black text-white pt-24 pb-12 px-6" data-id="element-121">
      <div className="max-w-[1800px] mx-auto grid grid-cols-1 md:grid-cols-4 gap-16" data-id="element-122">
        <div className="space-y-8" data-id="element-123">
          <h3 className="text-sm font-display font-bold tracking-[0.3em] uppercase" data-id="element-124">
            Djily Creations
          </h3>
          <p className="text-sm font-light tracking-widest leading-relaxed text-white/60 uppercase" data-id="element-125">
            A sanctuary of cultural authority where ancestral African
            craftsmanship meets contemporary luxury.
          </p>
          <div className="flex flex-col space-y-4 md:flex-row md:space-y-0 md:space-x-6" data-id="element-126">
            <a href="tel:5718423307" className="text-xs font-display tracking-[0.2em] uppercase hover:text-white/60 transition-colors" data-id="element-127">
              (571) 842-3307
            </a>
            <a href="mailto:concierge@djilicreations.com" className="text-xs font-display tracking-[0.2em] uppercase hover:text-white/60 transition-colors break-all" data-id="element-128">
              concierge@djilicreations.com
            </a>
          </div>
        </div>

        <div data-id="element-129">
          <h4 className="text-xs font-display font-bold tracking-widest uppercase mb-8 text-white/40" data-id="element-130">
            Collections
          </h4>
          <ul className="space-y-4" data-id="element-131">
            {[{
            name: 'New In',
            path: '/new-in'
          }, {
            name: 'Djily',
            path: '/djily'
          }, {
            name: 'Djily Heritage',
            path: '/djily-heritage'
          }, {
            name: 'Djily Studio',
            path: '/djily-studio'
          }].map(item => <li key={item.name} data-id="element-132">
                <Link to={item.path} className="text-xs font-display tracking-[0.2em] uppercase hover:text-white/60 transition-colors" data-id="element-133">
                  {item.name}
                </Link>
              </li>)}
          </ul>
        </div>

        <div data-id="element-134">
          <h4 className="text-xs font-display font-bold tracking-widest uppercase mb-8 text-white/40" data-id="element-135">
            The Studio
          </h4>
          <ul className="space-y-4" data-id="element-136">
            {[{
            name: 'About Us',
            path: '/about'
          }, {
            name: 'Studio',
            path: '/studio'
          }, {
            name: 'Meet the Team',
            path: '/meet-the-team'
          }, {
            name: 'Studio Hours',
            path: '/studio-hours'
          }].map(item => <li key={item.name} data-id="element-137">
                <Link to={item.path} className="text-xs font-display tracking-[0.2em] uppercase hover:text-white/60 transition-colors" data-id="element-138">
                  {item.name}
                </Link>
              </li>)}
          </ul>
        </div>

        <div data-id="element-139">
          <h4 className="text-xs font-display font-bold tracking-widest uppercase mb-8 text-white/40" data-id="element-140">
            Contact
          </h4>
          <ul className="space-y-4 text-xs font-display tracking-[0.2em] uppercase text-white/80" data-id="element-141">
            <li data-id="element-142">Alexandria, VA</li>
            <li data-id="element-143">
              <a href="tel:5718423307" className="hover:text-white transition-colors" data-id="element-144">
                (571) 842-3307
              </a>
            </li>
            <li data-id="element-145">
              <a href="mailto:concierge@djilicreations.com" className="hover:text-white transition-colors break-all" data-id="element-146">
                concierge@djilicreations.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1800px] mx-auto mt-24 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-147">
        <p className="text-[10px] font-display tracking-widest uppercase text-white/40" data-id="element-148">
          © 2024 Djily Creations. All Rights Reserved.
        </p>
        <div className="flex space-x-8 text-[10px] font-display tracking-widest uppercase text-white/40" data-id="element-149">
          <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-150">
            Privacy Policy
          </Link>
          <Link to="/terms-of-service" className="hover:text-white transition-colors" data-id="element-151">
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>;
}